import React, { useEffect, useState } from 'react';
import { clearProcessConfirmData, MessageConfirm } from '@app/src/views/StepConfirm/sectionConfirm';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { isClientEnv } from '@app/src/utils/validations';
import { Title } from '@app/src/views/StepConfirm/sectionConfirm';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();

const confirmConfig = {
  'purchase-print': {
    title: 'Tu compra se realizó con éxito',
    message: 'Te hemos enviado un correo con el detalle de tu compra',
    buttonNextText: 'Comprar un aviso'
  },
  'consume-print': {
    title: 'Tu publicación se realizó con éxito',
    message: '',
    buttonNextText: 'Crear un aviso'
  },
  'purchase-package': {
    title: 'Tu compra se realizó con éxito',
    message: 'Te hemos enviado un correo con el detalle de tu compra',
    buttonNextText: 'Crear un aviso'
  }
};

export const StepConfirm: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const locationState = location && location.state;
  const urlFromBefore = locationState && locationState.from;
  const order = useSelector(state => state.processConfirm.data.transactionId);
  const date = useSelector(state => state.processConfirm.data.date);
  const duration = useSelector(state => state.processConfirm.data.duration);
  const price = useSelector(state => state.processConfirm.data.total);
  const urlConsume = useSelector(state => state.processConfirm.data.urlConsume);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getCategory = () => print && print.general && print.general.category;
  const packageCategory = useSelector(state => state.package.categorySelected);
  const typePayment = useSelector(state => state.session.user.pasarella);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const [currentConfig, setCurrentConfig] = useState(null);
  const [theme, setTheme] = useState(null);
  const confirmData = useSelector(state => state.processConfirm.data);

  useEffect(() => {
    return() => {
      dispatch(clearProcessConfirmData());
    }
  }, []);

  useEffect(() => {
    if (typePayment && confirmData && Object.keys(confirmData).length > 0) {
      setCurrentConfig(confirmConfig[typePayment]);
      if (typePayment === 'purchase-package') {
        setTheme(CATEGORIES[CATEGORY[packageCategory]]);
        pushDatalayerPackage(theme && theme.name);
      }
      if (urlFromBefore === 'purchase-print') {
        pushDatalayer(theme && theme.name);
        setTheme(CATEGORIES[CATEGORY[getCategory()]]);
      }
    } else {
      history.push('/');
    }
  }, [typePayment, confirmData]);

  const pushDatalayer = (categoryName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': `Confirmación de Pago - ${categoryName} - Tarjeta`,
        'eventAction': `Paso 4 - ${categoryName}`,
        'eventLabel': `${order}|${date}|S/ ${price}`,
        'eventValue': 1
      })
    }
  };

  const pushDatalayerPackage = (categoryName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EvPasosdecompra',
        'category': `P3_${categoryName}`,
        'action': `${userStorage && userStorage.titleLayer}_${userStorage && userStorage.facture}_Tarjeta`,
        'label': userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
        'value': price
      })
    }
  };

  const setRedirect = () => {
    if (typePayment === 'purchase-package') {
      return urlConsume;
    }
    if (typePayment === 'consume-print') {
      return urlConsume;
    }
    if (urlFromBefore === 'purchase-print') {
      return theme.paths.purchasePrint.stepOne;
    }
  };

  const handleClickNext = () => {
    const urlNext = setRedirect();
    if (isClient) {
      sessionStorage.removeItem('print');
      sessionStorage.removeItem('printWeb');
      window.location.href = urlNext;
    }
  };

  return (
    <React.Fragment>
      {
        <MessageConfirm
          message={currentConfig && currentConfig.message.replace('***', duration)}
          buttonText={currentConfig && currentConfig.buttonNextText}
          theme={COLORS.BLACK_BOLD}
          handleClickNext={handleClickNext}
          details={typePayment !== 'consume-print' && [
            {
              description: 'Número de orden',
              value: order
            },
            {
              description: 'Fecha',
              value: date
            },
            {
              description: 'Total (inc. IGV)',
              value: price,
              price: true
            }
          ]}
        >
        <Title
          imgSrc={theme && theme.successImage}
          text={currentConfig && currentConfig.title}
        />
        </MessageConfirm>
      }
    </React.Fragment>
  )
};
